<template>
  <div class="user-group">
    <el-card>
      <div slot="header" class="card-header">
        <span>{{ $t('userGroup.title') }}</span>
        <el-button type="primary" size="small" @click="handleAdd">{{ $t('userGroup.addGroup') }}</el-button>
      </div>

      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" :label="$t('userGroup.colId')" width="70"></el-table-column>
        <el-table-column prop="color" :label="$t('userGroup.colColor')" width="80">
          <template slot-scope="scope">
            <div :style="{ background: scope.row.color, width: '30px', height: '30px', borderRadius: '4px' }"></div>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('userGroup.colName')"></el-table-column>
        <el-table-column prop="description" :label="$t('userGroup.colDesc')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sort_order" :label="$t('userGroup.colSort')" width="70"></el-table-column>
        <el-table-column prop="members_count" :label="$t('userGroup.colMembers')" width="80"></el-table-column>
        <el-table-column :label="$t('userGroup.colAction')" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">{{ $t('userGroup.edit') }}</el-button>
            <el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row)">{{ $t('userGroup.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getList, deleteGroup } from '@/api/userGroup'

export default {
  name: 'UserGroup',
  data() {
    return {
      list: [],
      loading: false
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    // 加载分组列表
    loadData() {
      this.loading = true
      getList().then(res => {
        this.list = res.data || []
      }).catch(() => {
        this.$message.error(this.$t('userGroup.loadFail'))
      }).finally(() => {
        this.loading = false
      })
    },
    // 新增分组
    handleAdd() {
      this.$router.push('/user-group/edit')
    },
    // 编辑分组
    handleEdit(row) {
      this.$router.push('/user-group/edit/' + row.id)
    },
    // 删除分组
    async handleDelete(row) {
      try {
        await this.$confirm(this.$t('userGroup.deleteConfirm'), this.$t('common.tip'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        })
        deleteGroup(row.id).then(() => {
          this.$message.success(this.$t('userGroup.deleteSuccess'))
          this.loadData()
        }).catch(() => {
          this.$message.error(this.$t('userGroup.deleteFail'))
        })
      } catch (e) {
        // 取消删除
      }
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}
</style>
